module.exports = __webpack_public_path__ + "static/img/IMG_20150610_204231.a0522341.jpg";